export default __webpack_public_path__ + "static/media/foto_07.a934b959.jpg";